import type { ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

type FieldHelperTextProps = {
  text?: ReactNode;
};

export const FieldHelperText = ({ text }: FieldHelperTextProps) => {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        color: theme.palette.grey[700],
        lineHeight: '20px',
        marginTop: '3px',
        padding: '0 16px',
      }}
      variant="helpertext"
    >
      {text}
    </Typography>
  );
};
